const initialState = false

export default function loadingReducer(state = initialState, action) {
	switch (action.type) {
		case 'LOADING_ON': {
			return true
		}
		case 'LOADING_OFF': {
			return false
		}
		default:
			return state
	}
}